import {gql} from 'apollo-angular';
import {JobPreviewFragment} from "./fragments/JobPreview";

export const GET_ALL_JOB_PREVIEWS = gql`
  query GetAllJobPreviews($search: String!) {
    jobMarkets(search: $search) {
      numResults
      entries {
        ...jobPreviewFields
      }
    }
  }
  ${JobPreviewFragment}
`;
